import React from 'react'

import { Button } from 'src/components/Button/Button'
import { Headline } from 'src/components/Headline/Headline'

import styles from './LinkToClaimSection.module.scss'

export const LinkToClaimSection = () => (
  <section className={styles.container}>
    <Headline variant="h3">Bist du bereit, den Schlüssel zu einer neuen Kaffeewelt zu verschenken?</Headline>
    <Button variant="primary" fullWidthMobile href="#gift-subscription-configure">
      Geschenkabo jetzt einrichten
    </Button>
  </section>
)
